export default __webpack_public_path__ + "scene0330f5c8.jpg";